import { apiContentItemBase, apiContentItemTranslation } from "@/services/contents/schemas"
import { z } from "zod"

/**
 * schemas
 */
export const itemType = "kultur-rallye"
export const limitTo = "a5812b75-7ac7-4025-8d0a-44e4ff750a66"
export const itemProps = z.object({
  titleLevel: z.number().default(1),
  image: z.string().nullable(),
  imageSmall: z.string().nullable(),
  contacts: z.string().array(),
})
export const itemTranslation = apiContentItemTranslation.extend({
  props: z.object({
    title: z.string(),
    secondary: z.string(),
    mapTitle: z.string(),
    mapSecondary: z.string(),
    content: z.string(),
    contactTitle: z.string(),
    contacts: z.record(
      z.string(),
      z.object({
        name: z.string(),
        company: z.string(),
        region: z.string(),
        email: z.string(),
      })
    ),
  }),
})

/**
 * exports
 */
export const apiContentItem = apiContentItemBase.extend({
  type: z.literal(itemType),
  props: itemProps,
  translations: itemTranslation.array(),
})
export type ApiContentItem = z.infer<typeof apiContentItem>
export type ItemType = typeof itemType
export type ItemProps = z.infer<typeof itemProps>
export type ItemTranslation = z.infer<typeof itemTranslation>
export type ContentItem = {
  type: ItemType
  props: ItemProps
  translations: ByLanguage<ItemTranslation>
}
